import React, { useState } from 'react';

interface AnnonceProps {
    // onValidate: (isValid: boolean) => void;
    // onSubmit: (texteAnnonce: string) => void;
    txtAnnonce: string;
    // denomination: string;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
}

const TransformationAutre: React.FC<AnnonceProps> = ({
    // onValidate,
    // onSubmit,
    txtAnnonce,
    updateTxtAnnonce,
    // denomination,
    updateDenomination
}) => {
    const [errors, setErrors] = useState<{ denomination?: string; texteAnnonce?: string }>({});
    const [denomination1, setDenomination1] = useState<string>('');
    const [rcs, setRCS] = useState<string>('');   
    const [capital, setCapital] = useState<string>(''); 
    const [codepostal, setCodepostal] = useState<number>(); 
    const [objetsocial, setObjetSocial] = useState<string>('');
    
    const [type, setType] = useState<string>('opt1');

    const [isTextareaVisible, setIsTextareaVisible] = useState(false);


    
     const [date, setDate] = useState<string>('');
    const [dateeffet, setDatEffet] = useState<string>('');
    const [sigle, setSigle] = useState<string>('');
    const [dateEffet, setDateEffet] = useState<string>('');
    const [orgDecision, setOrgDecision] = useState<string>('option01');
    const [formejuridique, setFormeJuridique] = useState<string>('option01');
    const [acte, setActe] = useState<string>('option01');
    const [activeTab, setActiveTab] = useState<string>('raisonSociale');
    const [referenceclient, setReferenceClient] = useState<string>('');
    const [actionType, setActionType] = useState<string>('');
    


    const OrgdeDecision = [
        { value: 'option001', label: 'AG Extraordinaire' },
        { value: 'option002', label: 'AG Ordinaire' },
        { value: 'option003', label: 'AG Mixte' },
        { value: 'option004', label: 'Le gérant' },
        { value: 'option005', label: 'Le président' },
        { value: 'option006', label: 'Conseil d\'administration' },
        { value: 'option007', label: 'L\'associé unique' },
        { value: 'option008', label: 'Décision unanime des associés' },
    ];
    const FormeJuridiques = [
        { value: 'option01', label: '' },
        { value: 'option02', label: 'Entreprise unipersonnelle à responsabilité limitée' },
    ];
    const Ville = [
        { value: 'opt01', label: 'ville' },
        { value: 'opt02', label: 'Ville' },
    ];
    const Type = [
        { value: 'opt1', label: 'Extension' },
        { value: 'opt2', label: 'Modification' },
    ]
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { id, value } = event.target;
        if (id === 'denomination') updateDenomination(value);
        if (id === 'texteAnnonce') updateTxtAnnonce(value);
    };

    const handlesigle = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSigle(event.target.value);
    }

    const Codepostal = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSigle(event.target.value);
    }

    const handlereferenceclient = (event: React.ChangeEvent<HTMLInputElement>) => {
        setReferenceClient(event.target.value);
    }

    // Fonction pour valider le format de la date (JJ/MM/AAAA)
    const validateDate = (value: string) => {
        const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
        return regex.test(value);
    };

    const handleDateChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        setDateFunc: React.Dispatch<React.SetStateAction<string>>,
        handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    ) => {
        let value = e.target.value.replace(/[^\d/]/g, ''); 
        
        if (value.length === 2 || value.length === 5) {
            value += '/'; 
        }
        
        if (value.length <= 10) {
            setDateFunc(value); 
        }
    
        handleChange(e);
    };

    const handleBlur = (value: string, setDateFunc: React.Dispatch<React.SetStateAction<string>>) => {
        if (!validateDate(value)) {
            setDateFunc('');
        }
    };

    const validate = () => {
        const newErrors: {
          denomination1?: string;
          ville?: string;
          greffe?: string;
          objetsocial?: string;
          texteAnnonce?: string;
        } = {};
      
        // Vérification si 'denomination1' est vide
        if (!formData.denomination1) {
          newErrors.denomination1 = "Le champ 'Dénomination' est obligatoire.";
        }
      
        // if (!formData.ville) {
        //   newErrors.ville = "Le champ 'Ville' est obligatoire.";
        // }
      
        // if (!formData.greffe) {
        //   newErrors.greffe = "Le champ 'Greffe' est obligatoire.";
        // }
      
        // if (!formData.objetsocial) {
        //   newErrors.objetsocial = "Le champ 'Objet Social' est obligatoire.";
        // }
      
        setErrors(newErrors);
      
        return Object.keys(newErrors).length === 0;
      };
      


    const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>, setState: React.Dispatch<React.SetStateAction<string>>) => {
        setState(event.target.value);
    };

    const switchTab = (tab: string) => {
        setActiveTab(tab);
    };

    const [formData , setFormData] = useState({
        denomination1: '',
        decision: '',
        date: '',
        dates:'',
        datees:'',
        rcs:'',
        capital:'',
        adresse:'',
        adresseeffet:'',
        formejuridique:'',
        codePostal:'',
        ville:'',
        greffe:'',
        type:'',
        objetsocial:'',
        denomination1nouvelle:'',
        capitalnouveau:''
    })

    const [submitted, setSubmitted] = useState<boolean>(false);

    const [submittedData, setSubmittedData] = useState<{ [key: string]: string } | null>(null);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault(); 
        if(validate()) {
            updateTxtAnnonce(`${formData.denomination1}\n AARPI au capital  de ${formData.capital}€ \n Siège social :\n ${formData.adresse} ${formData.adresseeffet} ${formData.codePostal} ${formData.ville}\n ${formData.rcs} de ${formData.greffe} \n l\'AGE du ${formData.date} à décidé de changer le capital social en le portant de : ${formData.capital}€ , à ${formData.capitalnouveau}€  \n Mention au RCS de ${formData.greffe}`)
             setSubmittedData(formData);
             setIsTextareaVisible(true);

        }
        console.log(formData); 
        // Affiche les données dans la console
      };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        
        setFormData({ ...formData, [e.target.id]: e.target.value });
    };

    return (
        <>     
                
        </>
    );
};

export default TransformationAutre;